import {Box, Button, Container, Grid, Modal, TextField, Typography} from '@mui/material';
import React, {useState} from 'react';
import {crearCodigoValidacionApi, recuperarCuentaApi} from './restablecerPassDtSource';
import {toast} from 'lib.front';
import CountdownButton from './components/CountdownButton';
import { makeStyles } from 'tss-react/mui';

const style = {
   modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '50%',
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      p: 4
   }
};

const useStyles = makeStyles()(theme => ({
   button: {
      color:'black', 
      '&:hover':{
        backgroundColor:'rgba(38,50,56,0.04)'
      },
   }
}));

const RestablecerPass = () => {
   const {classes} = useStyles();
   const [correoVal, setCorreoVal] = useState('');
   const [correoError, setCorreoError] = useState(false);
   const [correoHelper, setCorreoHelper] = useState('');

   const [codValidation, setCodValidation] = useState('');
   const [codError, setCodError] = useState(false);
   const [codHelper, setCodHelper] = useState('');

   const clearAll = () => {
      setCorreoVal('');
      setCorreoError(false);
      setCorreoHelper('');
      setCodValidation('');
      setCodError(false);
      setCodHelper('');
   };

   const [openCorreoModal, setOpenCorreoModal] = useState(false);
   const handleOpenCorreoModal = () => setOpenCorreoModal(true);
   const handleCloseCorreoModal = () => setOpenCorreoModal(false);

   const [openCodVerificacionModal, setOpenCodVerificacionModal] = useState(false);
   const handleOpenCodVerificacionModal = () => setOpenCodVerificacionModal(true);
   const handleCloseCodVerificacionModal = () => setOpenCodVerificacionModal(false);

   const [startTimeSancion, setStartTimeSancion] = useState();
   const [duracionSancionMs, setDuracionSancion] = useState(0);

   const validarCorreo = correo => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(correo);
   };

   const handleGenerarCodValidacion = async () => {
      if (!validarCorreo(correoVal)) {
         setCorreoError(true);
         setCorreoHelper(
            'El correo ingresado no es válido, por favor ingrese su correo correctamente'
         );
         return;
      }
      setCorreoError(false);
      setCorreoHelper('');
      const {data, error} = await crearCodigoValidacionApi(correoVal);
      if (error && error.mensaje) {
         if (error.code === '404') {
            setCorreoError(true);
            setCorreoHelper(error.mensaje);
         } else {
            handleCloseCorreoModal();
            handleOpenCodVerificacionModal();
            const time = new Date(error.creadoEn);
            setStartTimeSancion(time);
            setDuracionSancion(error.duracion);
            setCodError(true);
            setCodHelper(error.mensaje);
         }
      } else {
         handleCloseCorreoModal();
         handleOpenCodVerificacionModal();
         toast.showSucces(data.mensaje);
         const time = new Date(data.creadoEn);
         setDuracionSancion(data.duracion);
         setStartTimeSancion(time);
      }
   };

   const handleEnviarCodigoValidacion = async () => {
      const {data, error} = await crearCodigoValidacionApi(correoVal);

      if (error && error.mensaje) {
         if (error.code === '404') {
            setCorreoError(true);
            setCorreoHelper(error.mensaje);
         } else {
            const time = new Date(error.creadoEn);
            setStartTimeSancion(time);
            setDuracionSancion(error.duracion);
            setCodError(true);
            setCodHelper(error.mensaje);
         }
      } else {
         toast.showSucces(data.mensaje);
         const time = new Date(data.creadoEn);
         setStartTimeSancion(time);
         setDuracionSancion(data.duracion);
      }
   };

   const handleConfirmarCodigoValidacion = async () => {
      if (!codValidation.trim()) {
         setCodError(true);
         setCodHelper('Ingrese el código de validación');
         return;
      }
      setCodError(false);
      setCodHelper('');
      const {data, error} = await recuperarCuentaApi(correoVal, codValidation);      
      if (error && error.mensaje) {
         setCodError(true);
         setCodHelper(error.mensaje);
      } else {
         handleCloseCodVerificacionModal();
         toast.showSucces(data.mensaje);
      }
   };

   return (
      <>
         <Button
            onClick={handleOpenCorreoModal}
            type="submit"
            variant="text"
            size="large"
            style={{color: 'blue', fontSize: '10px'}}
         >
            ¿Olvidó su contraseña?
         </Button>
         {/* Modal para ingresar correo */}
         <Modal open={openCorreoModal} onClose={handleCloseCorreoModal}>
            <Box sx={style.modal}>
               <Container>
                  <Typography variant="h4">Recuperar Contraseña</Typography>
                  <Typography sx={{mt: 2}}>
                     Introduzca su dirección de correo electrónico.
                  </Typography>
                  <Grid container item xs={12} sx={{justifyContent: 'center'}}>
                     <TextField
                        fullWidth
                        label="Correo"
                        value={correoVal}
                        onChange={e => setCorreoVal(e.target.value.replace(/\s/g, ''))}
                        error={correoError}
                        helperText={correoHelper}
                        variant='standard'
                     />
                  </Grid>
                  <Box display="flex" justifyContent="space-between" sx={{paddingTop: '15px'}}>
                     <Button
                        className={classes.button}
                        onClick={() => {
                           handleCloseCorreoModal();
                           clearAll();
                        }}
                     >
                        Cerrar
                     </Button>
                     <Button className={classes.button} onClick={handleGenerarCodValidacion}>Enviar código validación</Button>
                  </Box>
               </Container>
            </Box>
         </Modal>
         {/* Modal para código de verificación */}
         <Modal open={openCodVerificacionModal} onClose={handleCloseCodVerificacionModal}>
            <Box sx={style.modal}>
               <Container>
                  <Typography variant="h4">Código de Verificación</Typography>
                  <Typography sx={{mt: 2}}>
                     Revise su correo e ingrese el código enviado a {correoVal}.
                  </Typography>
                  <Grid container item xs={12} sx={{justifyContent: 'center'}}>
                     <TextField
                        fullWidth
                        label="Código de Validación"
                        value={codValidation}
                        onChange={e => setCodValidation(e.target.value.replace(/\s/g, ''))}
                        error={codError}
                        helperText={codHelper}
                        variant='standard'
                     />
                  </Grid>
                  <Box display="flex" justifyContent="space-between" sx={{paddingTop: '15px'}}>
                     <Button
                        className={classes.button}
                        onClick={() => {
                           handleCloseCodVerificacionModal();
                           clearAll();
                        }}
                     >
                        Cerrar
                     </Button>
                     <CountdownButton
                        startTime={startTimeSancion}
                        durationMs={duracionSancionMs}
                        textoActivo="Reenviar Código Validación"
                        textoContando="Esperar..."
                        onClick={handleEnviarCodigoValidacion}
                        className={classes.button}
                     />
                     {/* <Button onClick={handleEnviarCodigoValidacion}>
                        Reenviar Código Validación
                     </Button> */}
                     <Button className={classes.button} onClick={handleConfirmarCodigoValidacion}>
                        Restablecer Contraseña
                     </Button>
                  </Box>
               </Container>
            </Box>
         </Modal>
      </>
   );
};

export default RestablecerPass;
